import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import localisations from './mailto/localisation';
import theme from 'theme/theme';
import utils from 'helpers/utils';
import { MailIcon } from 'assets/materialIcons/materialIcons';

const MailTo = (props) => {
    const handleMailTo = () => {
        const {
            booking: {
                email,
                locale,
            },
            bookingId,
            costs,
            link,
            price,
            title,
        } = props;

        // Newline.
        const newLine = '%0A';

        // Booking locale.
        const bookingLocale = locale || 'en';

        // Subject.
        const subjectLabel = localisations[bookingLocale].subject;
        const subject = `${ subjectLabel } ${ bookingId }`;

        // Payment Link
        const paymentLink = {
            label: `${ localisations[bookingLocale].content.payment_link }:`,
            value: link,
        };

        // Payment Method
        const paymentTitle = {
            label: `${ localisations[bookingLocale].content.payment_title }:`,
            value: title,
        };

        // Price difference
        const priceDifference = {
            label: `${ localisations[bookingLocale].content.price_difference }:`,
            value: utils.formatPrice(price.difference, price.currency, bookingLocale),
        };

        // Transaction costs
        const transactionCosts = {
            label: `${ localisations[bookingLocale].content.transaction_costs }:`,
            value: utils.formatPrice(costs, price.currency, bookingLocale),

        };

        // Creating the template
        let body = [
            encodeURIComponent(paymentLink.label),
            encodeURIComponent(paymentLink.value),
            '',
            encodeURIComponent(paymentTitle.label),
            encodeURIComponent(paymentTitle.value),
            '',
            encodeURIComponent(priceDifference.label),
            encodeURIComponent(priceDifference.value),
            '',
            encodeURIComponent(transactionCosts.label),
            encodeURIComponent(transactionCosts.value),
        ].join(newLine);

        return window.open(`mailto:${ email }?subject=${ encodeURIComponent(subject) }&body=${ body }`);
    };

    return (
        <FlatButton
            backgroundColor={ theme.palette.envy }
            hoverColor={ theme.palette.chinook }
            onTouchTap={ handleMailTo }
            icon={ <MailIcon color={ theme.palette.white } /> }
            style={ { verticalAlign: 'top' } }
        />
    );
};

MailTo.propTypes = {
    booking: PropTypes.shape({
        email: PropTypes.string,
        locale: PropTypes.string,
    }),
    bookingId: PropTypes.number,
    costs: PropTypes.number.isRequired,
    link: PropTypes.string.isRequired,
    price: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
};

export default MailTo;



// WEBPACK FOOTER //
// ./src/components/transaction/paymentLink/MailTo.js